class MilestonesTimeline extends HTMLElement {
  connectedCallback() {
    this.sidebar = this.querySelector('.milestones-tl__sidebar');
    this.lineFill = this.querySelector('.milestones-tl__line-fill');
    this.yearLinks = Array.from(this.querySelectorAll('.milestones-tl__year-link'));
    this.milestoneItems = Array.from(this.querySelectorAll('.milestone-item'));
    this.animatedEls = Array.from(this.querySelectorAll('.milestone-animate'));

    if (!this.milestoneItems.length) return;

    this.ticking = false;
    this.activeIndex = 0;

    this.buildSidebar();
    this.yearLinks = Array.from(this.querySelectorAll('.milestones-tl__year-link'));
    this.setupYearClicks();
    this.setupSidebarVisibility();
    this.onScroll();

    window.addEventListener('scroll', () => this.requestTick(), { passive: true });
    window.addEventListener('resize', () => this.requestTick(), { passive: true });

    setTimeout(() => this.setupEntranceObserver(), 100);
  }

  requestTick() {
    if (!this.ticking) {
      this.ticking = true;
      requestAnimationFrame(() => {
        this.onScroll();
        this.ticking = false;
      });
    }
  }

  onScroll() {
    this.updateActiveYear();
    this.updateLineFill();
    this.updateParallax();
    this.updateMobileYearLinks();
    if (this._updateSidebarVisibility) this._updateSidebarVisibility();
  }

  updateActiveYear() {
    const trigger = window.scrollY + window.innerHeight * 0.5;
    let newActive = 0;

    for (let i = 0; i < this.milestoneItems.length; i++) {
      const rect = this.milestoneItems[i].getBoundingClientRect();
      const top = rect.top + window.scrollY;
      if (trigger >= top) {
        newActive = i;
      }
    }

    if (newActive !== this.activeIndex) {
      this.activeIndex = newActive;
      this.yearLinks.forEach((link, i) => {
        link.classList.toggle('is-active', i === newActive);
      });

      const activeLink = this.yearLinks[newActive];
      if (activeLink && this.sidebar) {
        const isHorizontal = window.innerWidth < 750;
        if (isHorizontal) {
          activeLink.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
    }
  }

  updateLineFill() {
    if (this.milestoneItems.length === 0 || !this.lineFill) return;

    const lineEl = this.lineFill.parentElement;
    const last = this.milestoneItems[this.milestoneItems.length - 1];

    const containerTop = lineEl.getBoundingClientRect().top + window.scrollY;
    const containerBottom = last.getBoundingClientRect().bottom + window.scrollY;
    const totalHeight = containerBottom - containerTop;

    if (totalHeight <= 0) return;

    const trigger = window.scrollY + window.innerHeight * 0.6;
    const progress = Math.max(0, Math.min(1, (trigger - containerTop) / totalHeight));

    this.lineFill.style.transform = 'scaleY(' + progress + ')';
  }

  updateParallax() {
    if (window.innerWidth < 750) return;
    const vh = window.innerHeight;
    this.milestoneItems.forEach((item) => {
      const img = item.querySelector('.milestone-item__image');
      if (!img) return;
      const rect = item.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const offset = ((center - vh / 2) / vh) * -30;
      img.style.transform = 'translateY(' + offset + 'px)';
    });
  }

  setupSidebarVisibility() {
    if (!this.sidebar) return;

    const isMobile = () => window.innerWidth < 750;
    const section = this;
    const sidebar = this.sidebar;

    const getHeaderBottom = () => {
      const el =
        document.getElementById('Header') ||
        document.querySelector('header-custom') ||
        document.getElementById('shopify-section-header') ||
        document.querySelector('header');
      if (!el) return 0;
      return Math.max(0, el.getBoundingClientRect().bottom);
    };

    const updateVisibility = () => {
      const sectionRect = section.getBoundingClientRect();

      if (isMobile()) {
        sidebar.style.top = getHeaderBottom() + 'px';
        const sectionBg = getComputedStyle(section).backgroundColor;
        sidebar.style.background =
          sectionBg && sectionBg !== 'rgba(0, 0, 0, 0)' ? sectionBg : '#fff';
        sidebar.style.opacity = '';
        sidebar.style.pointerEvents = '';
        sidebar.style.transform = '';

        const threshold = window.innerHeight * 0.2;
        const inRange = sectionRect.top < threshold && sectionRect.bottom > 0;
        sidebar.classList.toggle('is-mobile-visible', inRange);
      } else {
        sidebar.classList.remove('is-mobile-visible');
        sidebar.style.top = '';
        sidebar.style.background = '';

        const mainEl = section.querySelector('.milestones-tl__main');
        if (!mainEl) return;
        const mainRect = mainEl.getBoundingClientRect();
        const isVisible = mainRect.top < window.innerHeight && mainRect.bottom > 0;
        sidebar.style.opacity = isVisible ? '1' : '0';
        sidebar.style.pointerEvents = isVisible ? 'auto' : 'none';
      }
    };

    this._updateSidebarVisibility = updateVisibility;

    updateVisibility();
  }

  buildSidebar() {
    if (!this.sidebar) return;
    this.milestoneItems.forEach((item, i) => {
      const year = item.getAttribute('data-milestone-year');
      if (!year) return;
      const link = document.createElement('a');
      link.href = '#' + item.id;
      link.className = 'milestones-tl__year-link' + (i === 0 ? ' is-active is-passed' : '');
      link.setAttribute('data-year', year);
      link.textContent = year;
      this.sidebar.appendChild(link);
    });
  }

  updateMobileYearLinks() {
    if (window.innerWidth >= 750) return;

    const sidebarBottom = this.sidebar
      ? this.sidebar.getBoundingClientRect().bottom
      : 0;

    this.milestoneItems.forEach((item, i) => {
      if (i === 0) return;
      const yearEl = item.querySelector('.milestone-item__year');
      if (!yearEl || !this.yearLinks[i]) return;
      const passed = yearEl.getBoundingClientRect().bottom < sidebarBottom;
      this.yearLinks[i].classList.toggle('is-passed', passed);
    });
  }

  setupEntranceObserver() {
    let lastScrollY = window.scrollY;
    let scrollingDown = true;

    window.addEventListener('scroll', () => {
      scrollingDown = window.scrollY > lastScrollY;
      lastScrollY = window.scrollY;
    }, { passive: true });

    const bottomMargin = window.innerWidth >= 750 ? '-130px' : '-70px';
    const enterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && scrollingDown) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px ' + bottomMargin + ' 0px' }
    );

    const exitObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top > 0) {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );

    this.animatedEls.forEach((el) => {
      enterObserver.observe(el);
      exitObserver.observe(el);
    });
  }

  setupYearClicks() {
    this.yearLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const target = document.getElementById(targetId);
        if (target) {
          const headerOffset = 100;
          const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    });
  }
}

customElements.define('milestones-timeline', MilestonesTimeline);
